import { Outlet, useLocation } from 'react-router-dom';
import Layout from '../components/ui/Layout';
import CreateAction from '../components/operational/createAction';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import myUserSlice from '../redux/myUserSlice';
import { useNavigate } from 'react-router-dom';
import myAppsSlice from '../redux/myAppsSlice';
import { license } from '../data/license';
function Store() {
    const [isStoreChecked, setIsStoreChecked] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const getStores = async () => {
        const activeStoreId = localStorage.getItem('activeStoreId');
        CreateAction({
            path: '/store',
            method: 'get',
            isFileUploading: false,
            data: '',
            showPreLoader: true,
        })
            .then((response) => {
                const stores = response?.result?.resultData;
                const app = stores.find((app) => app?.id === activeStoreId);
                if (stores?.length === 0) {
                    return navigate('/createapp')
                }
                if (
                    (!app || !activeStoreId || app?.id != activeStoreId) &&
                    window.location.pathname !== '/chooseApp'
                )
                    navigate('/chooseApp'); //the user can only access chooseApp if no app selected.

                dispatch(
                    myAppsSlice.actions.setLocalReduxData({
                        apps: stores,
                        stores: stores,
                        app,
                    }),
                );
                dispatch(myUserSlice.actions.setProviderData(app.providerData));
                dispatch(myUserSlice.actions.setMerchantId(app.merchantId));
                const storeLicense = license[app?.activeLicense?.licenseType] || license['FREE'];
                dispatch(myUserSlice.actions.setLicense(storeLicense));
            })
            .catch(error => {
                // localStorage.clear()
                // navigate("/login")
            })
            .finally(() => {
                setIsStoreChecked(true);
            });
    };

    useEffect(() => {
        getStores();
    }, []);

    return isStoreChecked ? <Outlet /> : <></>;
}

export default Store;
